<template>
  <div>

    <div class="card dashcard mb-0">
      <div class="card-body">
        <div class="form-row">
          <div class="col col-12 col-md-6">
            <az-periodo v-model="filtro" :sync="true" @sync="load()" />
          </div>
          <div class="col col-12 col-md-2">
            <az-input 
              type="select" 
              icon="fa fa-calendar-o fa-fw"
              placeholder="Vencimento"
              :optionsList="[
                { id: 'E', search: 'Emissão' },
                { id: 'B', search: 'Baixa' },
                { id: 'P', search: 'Pagamento' },
                { id: 'C', search: 'Competência' },
                { id: 'L', search: 'Lançamento' },
              ]"
              optionsData="id"
              optionsDisplay="search"
              v-model="filtro.tipo_data">
            </az-input>
          </div>
          <div class="col col-12 col-md-2">
            <az-input
              type="select"
              icon="fas fa-funnel-dollar"
              placeholder="Todos"
              optionsData="id"
              :optionsList="[
                { id: 'C', search: 'Contas a Receber'}, 
                { id: 'D', search: 'Contas a Pagar'},
                { id: 'T', search: 'Transferências'},
                { id: 'O', search: 'Créditos de Operadoras'},
              ]"
              :edicao="!cred_oper"
              v-model="filtro.natureza" />
          </div>
          <div class="col col-12 col-md-2">
            <az-input
              placeholder="Todas as Formas..."
              icon="fas fa-cash-register"
              type="select"
              optionsMode="aql"
              service="forma_pagamentos.index"
              optionsData="id_forma_pagamento"
              optionsDisplay="search"
              v-model="filtro.id_forma_pagamento" />
          </div>
        </div>

        <div class="form-row mt-2">
          <div class="col col-12 col-md-2">
            <az-input
              type="select"
              icon="fa fa-filter fa-fw"
              placeholder="Todos os Status..."
              optionsData="id"
              :optionsList="[
                { id: 'A', search: 'Em Aberto'}, 
                { id: 'T', search: 'Em Atraso'}, 
                { id: 'F', search: 'Efetuadas'}, 
                { id: 'C', search: 'Cancelados'},
                { id: 'R', search: 'Reprogramados'}
              ]"
              v-model="filtro.status" />
          </div>
          <!-- Seleção da Operadora / Fornecedor -->
          <div class="col col-12 col-md-3" v-if="filtro.natureza == 'C' || filtro.natureza == 'O'">
            <az-input
                :key="'cliente'"
                icon="far fa-credit-card fa-fw"
                type="autocomplete" 
                optionsMode="aql"
                optionsData="id_operadora"
                optionsDisplay="st_operadora"
                :optionsParms="{ ativos: true }"
                service="operadoras.index"
                optionsName="operadoras-para-lancamento"
                placeholder="Todos os Clientes..."
                v-model="filtro.id_operadora">
            </az-input>
          </div>

          <div class="col col-12 col-md-3" v-else>
            <az-input
              placeholder="Todas as Empresas..."
              icon="fas fa-store fa-fw"
              type="autocomplete"
              optionsMode="aql"
              service="fornecedores.index"
              :optionsParm="{ ativas: true }"
              optionsData="id_fornecedor"
              optionsDisplay="search"
              v-model="filtro.id_fornecedor" />
          </div>
          <div class="col col-12 col-md-3">
            <az-input
              :edicao="!$store.state.user.id_unidade_operacao"
              icon="far fa-building fa-fw"
              type="select"
              placeholder="Todas as Unidades..."
              :optionsList="$util.unidades_com_tags(true, true)"
              optionsData="id_unidade_operacao"
              v-model="filtro.id_unidade_operacao" />
          </div>
          <div class="col col-12 col-md-4">
            <az-input
                icon="fas fa-funnel-dollar fa-fw"
                type="select"
                placeholder="Todos os Centros de Custo..."
                :optionsList="lista_centro_custo"
                optionsData="id_centro_custo"
                :edicao="( filtro.id_unidade_operacao && !isNaN(filtro.id_unidade_operacao) ) ? true : false"
                v-model="filtro.id_centro_custo" />
          </div>
        </div>

        <div class="form-row mt-2">
          <div class="col col-12 col-md-2">
            <az-input
              type="checkbox-group"
              label="Conciliado"
              v-model="filtro.conciliado" />
          </div>
          <div class="col col-12 col-md-3">
            <az-input
              placeholder="Categoria..."
              icon="fas fa-quote-left fa-fw"
              type="autocomplete"
              optionsMode="aql"
              service="categorias.index"
              optionsName="categoria.index.lancamentos.niveis"
              optionsData="id_categoria"
              optionsDisplay="search"
              :optionsParm="{ ativas_completa: true }"
              v-model="filtro.id_categoria">
            </az-input>
          </div>
          <div class="col col-12 col-md-5">
            <az-input
              icon="fa fa-search fa-fw" 
              placeholder="Pesquisar por (ou digite # + número do lançamento)..."
              :shortkey="['ctrl', 'p']"
              v-model="filtro.search"
              @onEnter="load()">
              <template v-slot:buttonposb>
                <div class="input-group-append">
                  <button class="btn btn-outline-primary" type="button" @click="incluir()" v-if="pode_editar">
                    <i class="fa fa-plus fa-fw" aria-hidden="true"></i>
                  </button>
                  <button class="btn btn-outline-secondary" type="button" @click="show_obs = !show_obs" title="Exibir observações.">
                    <i class="fa-solid fa-comment-slash fa-fw" v-if="!show_obs"></i>
                    <i class="fa-solid fa-comment fa-fw" v-else></i>
                  </button>
                </div>
                <importacao service="lancamentos" @refresh="load()" v-if="pode_editar">
                  <template v-slot:instrucao>
                    <p class="alert alert-info">
                      <ul class="mb-0">
                        <li>A "Chave Externa do Lançamento" deve ser preenchida com o número de identificação do lançamento no sistema de origem. Se existirem parcelas, as diversas parcelas devem ter a mesma chave.</li>
                        <li>O campo de CPF/CNPJ deve ser informado apenas com números (sem formatação)</li>
                        <li>Os campos de valor devem ser informados sem "vírgula" (x100)</li>
                      </ul>
                    </p>
                  </template>
                </importacao>
                <print-export printid="lista-lancamentos" :left="true" :dados="dadosFormatados" model_type="lancamento" pagina="lancamentos" :parms="parms_relat_linkados">
                    <template v-slot:downloaddropdownitem>
                        <div class="dropdown-divider"></div>
                        <a class="dropdown-item" href="#" @click.prevent="abrir_unecont()">
                            <i class="fa-solid fa-file-import mr-2"></i>
                            UneCont
                        </a>
                    </template>
                </print-export>
              </template>
            </az-input>
          </div>
          <div class="col col-12 col-md-2">
            <az-input
              type="checkbox-group"
              :label="filtro.retroativo ? '' : 'Retroativo'"
              v-model="filtro.retroativo">
              <template v-slot:buttonposcb>
                <input type="date" class="form form-control" v-model="filtro.dt_retroativo" v-if="filtro.retroativo" />
              </template>
            </az-input>
          </div>
        </div>
      </div>
    </div>

    <div class="progress mt-1 mb-3">
        <div class="indeterminate" v-if="$store.state.loading && dados"></div>
        <div class="determinate" v-else></div>
    </div>

    <div id="lista-lancamentos" v-if="dados && lista.length">

      <div class="alert alert-info" v-if="parametros && parametros.natureza == 'O'">
        Créditos de Operadoras
      </div>

      <div class="alert alert-warning" v-if="parametros && parametros.dt_retroativo">
        Retroativo: {{ $util.getFormatDate(parametros.dt_retroativo) }}
      </div>

      <template v-if="consolidado && consolidado.length">
        <table class="table table-hover table-responsive-md table-sm bg-white mt-3 small">
          <thead>
            <tr>
              <th>Operadora</th>
              <th class="text-right">Qtd</th>
              <th class="text-right">Retenções</th>
              <th class="text-right">Valor</th>
              <th class="text-right">Uso</th>
              <th class="text-right">Saldo</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(cred, icx) in consolidado" :key="icx">
              <td><a href="#" @click.prevent="filtro_operadora = cred" class="card-link">{{ cred.item }}</a></td>
              <td class="text-right">{{ cred.qtd }}</td>
              <td class="text-right">{{ $util.formatMoeda(cred.retencao) }}</td>
              <td class="text-right">{{ $util.formatMoeda(cred.liquido) }}</td>
              <td class="text-right">{{ $util.formatMoeda(cred.uso) }}</td>
              <td class="text-right">{{ $util.formatMoeda(cred.saldo) }}</td>
            </tr>
          </tbody>
          <tfoot>
            <tr>
              <th>Total</th>
              <th class="text-right">{{ totalizar(consolidado, 'qtd') }}</th>
              <th class="text-right">{{ $util.formatMoeda(totalizar(consolidado, 'retencao')) }}</th>
              <th class="text-right">{{ $util.formatMoeda(totalizar(consolidado, 'liquido')) }}</th>
              <th class="text-right">{{ $util.formatMoeda(totalizar(consolidado, 'uso')) }}</th>
              <th class="text-right">{{ $util.formatMoeda(totalizar(consolidado, 'saldo')) }}</th>
            </tr>
          </tfoot>
        </table>
      </template>

      <az-input
        sizing="sm"
        v-if="filtro_operadora"
        :edicao="false"
        v-model="filtro_operadora.item">
        <template v-slot:button-pre>
          <div class="input-group-prepend">
            <button type="button" class="btn btn-outline-danger" @click="filtro_operadora = ''">
              <i class="fa fa-times" aria-hidden="true"></i>
            </button>
          </div>
        </template>
      </az-input>

      <div class="d-none d-print-block mt-3">
        <h4>{{ $store.state.unidade.st_nome_fantasia }}</h4>
        <h3>Lançamentos</h3>
        <div class="alert alert-secondary">
          <div v-if="parametros">Período: ({{ parametros.tipo }}) {{ $util.getFormatDate(parametros.inicio) }} a {{ $util.getFormatDate(parametros.fim) }}</div>
          <div v-if="parametros && parametros.unidade">Unidade: {{ parametros.unidade }}</div>
        </div>
      </div>

      <table class="table table-hover table-responsive-md bg-white mt-3 small" :class="view ? 'cabecalho-fixo-modal' : 'cabecalho-fixo'">
        <thead>
          <tr>
            <table-th title="Vencimento" v-model="ordem" sortby="dt_vencimento"></table-th>
            <th v-if="parametros && parametros.tipo_data && parametros.tipo_data != 'C'">{{ parametros.tipo }}</th>
            <th>Histórico</th>
            <th v-if="$store.state.unidade.unidade_operacaos.length > 1 && ( !parametros || !parametros.unidade || parametros.unidade.substr(0,1) == '#' )">Unidade</th>
            <th>Competência</th>
            <th>Categoria</th>
            <table-th title="Valor" v-model="ordem" sortby="dc_valor" align="text-right"></table-th>
            <th class="d-print-none">
              Ações
            </th>
            <th v-if="parametros && parametros.natureza == 'O'" class="text-right">
              Saldo
            </th>
            <th class="text-center" v-else>
              <button type="button" class="btn btn-outline-primary btn-sm d-print-none" @click="marcar_todos()" v-if="pode_editar">
                Todos
              </button>
            </th>
            <th v-if="parametros && ( parametros.natureza == 'C' || parametros.natureza == 'D' )" class="text-right">
              Saldo
            </th>
          </tr>
        </thead>
        <tbody v-if="natureza_unica || ( parametros && parametros.natureza == 'O' ) || filtro.natureza == 'C' || filtro.natureza == 'D' || ( parametros && parametros.id_categoria )">
          <tr>
            <th colspan="4">
              Total
              <span class="badge badge-secondary ml-3">
                {{ lista.length }}
              </span>
            </th>
            <th v-if="$store.state.unidade.unidade_operacaos.length > 1 && ( !parametros || !parametros.unidade || parametros.unidade.substr(0,1) == '#' )"></th>
            <th v-if="parametros && parametros.tipo_data && parametros.tipo_data != 'C'"></th>
            <th class="text-right">
              <template v-if="parametros && ( parametros.tipo_data != 'B' || parametros.natureza == 'O' )">
                {{ $util.formatMoeda(total_lancamentos) }}
                <div>
                  <small class="text-muted" v-if="total_lancamentos != total_lancamentos_sem_adiant">
                    {{ $util.formatMoeda(total_lancamentos_sem_adiant) }}
                  </small>
                </div>
              </template>
            </th>
            <th></th>
            <th class="text-right">
              <span v-if="parametros && parametros.natureza == 'O'">
                {{ $util.formatMoeda(total_saldo_creditos) }}
                <div class="text-muted">
                  Uso: {{ $util.formatMoeda(total_uso_creditos) }}
                </div>
              </span>
              <span v-else>
                {{ $util.formatMoeda(total_baixas) }}
              </span>
            </th>
            <th class="text-right" v-if="parametros && ( parametros.natureza == 'C' || parametros.natureza == 'D' )">
              {{ $util.formatMoeda(total_saldo_liq) }}
            </th>
          </tr>
        </tbody>
        <tbody>
          <template v-for="(lanc, idx) in lista">
            <tr :key="idx" :class="lanc.ch_estado == 'R' ? 'table-warning' : ''" v-if="true">
              <td :class="lanc.dt_vencimento < $util.hoje() ? 'text-danger' : ''">
                {{ $util.getFormatDate(lanc.dt_vencimento) }}
                <div>
                    #{{ lanc.id_lancamento }}
                    <i class="fa-solid fa-file-check text-success" v-if="lanc.id_nota_fiscal_externa"></i>
                </div>
                <div class="badge badge-warning" v-if="lanc.ch_estado == 'R'">Reprogramado</div>
              </td>
              <th v-if="parametros && parametros.tipo_data && parametros.tipo_data != 'C'">
                <span v-if="parametros.tipo_data == 'B' && lanc.baixa && lanc.baixa.dt_baixa">
                  {{ $util.getFormatDate(lanc.baixa.dt_baixa) }}
                </span>
                <span v-else-if="parametros.tipo_data == 'P' && lanc.dt_pagamento">
                  {{ $util.getFormatDate(lanc.dt_pagamento) }}
                </span>
                <span v-else-if="parametros.tipo_data == 'L' && lanc.created_at">
                  {{ $util.getFormatDate(lanc.created_at) }}
                </span>
                <span v-if="parametros.tipo_data == 'E' && lanc.dt_emissao">
                  {{ $util.getFormatDate(lanc.dt_emissao) }}
                </span>
              </th>
              <td>
                <div v-if="lanc.baixa && lanc.baixa.id_baixa_multipla">
                  <a href="#" @click.prevent="carregar_baixa_multipla (lanc)" class="card-link mb-2"  title="Baixa Múltipla">
                    <span class="badge badge-primary">
                      #{{ lanc.baixa.id_baixa_multipla }}
                      <span v-if="lanc.baixa.multipla" class="ml-2">
                        {{ lanc.baixa.multipla.st_descricao }}
                      </span>
                    </span>
                  </a>
                </div>
                <i class="fas fa-exchange-alt" v-if="lanc.ch_tipo_lancamento == 'T' || lanc.ch_tipo_lancamento == 'M'"></i>
                <i class="fa-solid fa-circle-half-stroke" :class="( lanc.ch_tipo_lancamento == 'D' ) ? 'text-danger' : 'text-success'" v-else-if="lanc.baixa && lanc.baixado && lanc.baixado.parcial" title="Baixado parcialmente."></i>
                <i class="fas fa-circle" :class="( lanc.ch_tipo_lancamento == 'D' ) ? 'text-danger' : 'text-success'" v-else-if="lanc.baixa" title="Baixado."></i>
                <i class="far fa-dot-circle" :class="( lanc.ch_tipo_lancamento == 'D' ) ? 'text-danger' : 'text-success'" v-else title="Não baixado."></i>
                <template v-if="lanc.ch_tipo_lancamento == 'T' || lanc.ch_tipo_lancamento == 'M'">
                  <span v-if="lanc.conta_origem" class="ml-1">{{ lanc.conta_origem.search }}</span>
                  <i class="fa fa-caret-right mx-1" aria-hidden="true"></i> 
                  <span v-if="lanc.conta_destino">{{ lanc.conta_destino.search }}</span>
                  <span class="text-muted ml-1">({{ lanc.st_descricao }})</span>
                </template>
                <template v-else>
                  <span v-if="lanc.fornecedor">
                    {{ lanc.fornecedor.search }}
                    <template v-if="lanc.fornecedor.sinalizadores && lanc.fornecedor.sinalizadores.length">
                        <span v-for="(sinalizador, isx) in lanc.fornecedor.sinalizadores" :key="isx" class="ml-1" :class="'text-' + sinalizador.sinalizador.st_cor" :title="sinalizador.sinalizador.st_titulo">
                            <i :class="sinalizador.sinalizador.st_icon"></i>
                        </span>
                    </template>
                    <i class="fa fa-caret-right mx-2" aria-hidden="true"></i>
                  </span>
                  <span v-if="lanc.operadora">
                    {{ lanc.operadora.search }}
                    <i class="fa fa-caret-right mx-2" aria-hidden="true"></i>
                  </span>
                  {{ lanc.st_descricao }}
                  <span v-if="lanc.st_doc" class="text-muted">
                    <i class="fa fa-caret-right mx-2" aria-hidden="true"></i>
                    {{ lanc.st_doc }}
                  </span>
                </template>

                <a href="#" @click.prevent="carregar_recorrencia (lanc.id_recorrencia)">
                  <i class="fas fa-sync-alt ml-2" v-if="lanc.id_recorrencia"></i>
                  <span class="badge badge-secondary ml-1" v-if="lanc.in_parcela">
                    {{ lanc.in_parcela }}/{{ lanc.in_total_parcelas }}
                  </span>
                </a>

                <a href="#" @click.prevent="abrir_anexar_arquivo(lanc)" class="ml-2 card-link d-print-none">
                  <i class="fa fa-plus" aria-hidden="true" v-if="!lanc.arquivos.length"></i>
                  <div class="spinner-border spinner-border-sm" role="status" v-else-if="lanc.carregando">
                    <span class="sr-only">Loading...</span>
                  </div>
                  <i class="fa fa-paperclip" aria-hidden="true" v-else></i>
                </a>
                
                <div v-if="lanc.js_classes && lanc.js_classes.length > 0">
                  <a href="#" @click.prevent="filtro.search == classe ? filtro.search = '' : filtro.search = classe" v-for="(classe, icx) in lanc.js_classes" :key="icx">
                    <span class="badge badge-success mr-1">
                      {{ classe }}
                    </span>
                  </a>
                </div>
                <span v-if="lanc.item_pagamento_atendimento && lanc.item_pagamento_atendimento.pagamento_atendimento.id_atendimento"
                  class="text-muted ml-2">
                  #{{ lanc.item_pagamento_atendimento.pagamento_atendimento.id_atendimento }}
                </span>
                <div class="text-muted" v-if="show_obs && lanc.st_observacoes">
                  {{ lanc.st_observacoes }}
                </div>

                <!-- Nota Fiscal -->
                <lancamento-nota-fiscal-info 
                  :lancamento="lanc" 
                  :exibe_numero="true"
                  v-if="parametros && parametros.natureza == 'C'" />
              </td>
              <td v-if="$store.state.unidade.unidade_operacaos.length > 1 && ( !parametros || !parametros.unidade || parametros.unidade.substr(0,1) == '#' )">
                <span v-if="lanc.unidade_operacao">
                  {{ lanc.unidade_operacao.st_sigla }}
                </span>
              </td>
              <td>
                {{ $util.getFormatDate(lanc.dt_competencia, 'MM/YYYY') }}
              </td>
              <td>
                <a href="#" @click.prevent="filtrar(lanc.categoria.st_categoria)" v-if="lanc.categoria" class="card-link">
                  {{ lanc.categoria.st_categoria }}
                </a>
                <span v-else>
                  {{ lanc.categorias ? lanc.categorias : ( lanc.ch_tipo_lancamento == 'T' ? 'Transferência' : ( lanc.ch_tipo_lancamento == 'M' ? 'Adiantamento' : '' ) ) }}
                </span>
              </td>
              <td class="text-right">
                {{ $util.formatMoeda(lanc.dc_valor) }}
                <div>
                  <small class="text-muted" v-if="( lanc.liquido || lanc.liquido === 0 ) && Math.round(lanc.liquido * 100) != Math.round(lanc.dc_valor * 100)">
                    {{ $util.formatMoeda(lanc.liquido) }}
                  </small>
                </div>
              </td>
              <td class="d-print-none text-nowrap">
                <template v-if="lanc.ch_estado == 'C'">
                  <a href="#" @click.prevent="editar(lanc)" v-if="pode_editar">
                    <span class="badge badge-danger">Cancelado</span>
                  </a>
                </template>

                <template v-else>
                  <a href="#" @click.prevent="editar(lanc)" class="d-print-none" v-if="pode_editar">
                    <i class="fas fa-pen"></i>
                  </a>

                  <a href="#" @click.prevent="registrar_baixa(lanc)" data-toggle="tooltip" data-placement="top" title="Registrar Baixa" class="mx-2 text-muted" v-if="!lanc.baixa">
                    <i class="far fa-check-circle"></i>
                  </a>
                  <span class="text-primary ml-2" data-toggle="tooltip" data-placement="top" title="Adiantamento Realizado" v-else-if="lanc.ch_tipo_lancamento == 'M'">
                    <i :class="lanc.baixado.icon ? lanc.baixado.icon : 'fas fa-check-circle'"></i>
                  </span>
                  <a href="#" @click.prevent="registrar_baixa(lanc)" class="mx-2" :class="( ( lanc.ch_tipo_lancamento == 'C' || lanc.ch_tipo_lancamento == 'A' ) ? 'text-success' : 'text-danger' )" v-else-if="lanc.ch_tipo_lancamento != 'T'" data-toggle="tooltip" data-placement="top" title="Baixa Realizada">
                    <i :class="lanc.baixado.icon ? lanc.baixado.icon : 'fas fa-check-circle'"></i>
                  </a>
                  <span class="text-primary ml-2" data-toggle="tooltip" data-placement="top" title="Transferência Realizada" v-else>
                    <i :class="lanc.baixado.icon ? lanc.baixado.icon : 'fas fa-check-circle'"></i>
                  </span>

                  <a href="#" @click.prevent="transferir_baixa_credito(lanc)" class="d-print-none mr-2" data-toggle="tooltip" data-placement="top" title="Identificar Crédito de Lançamento" v-show="!pode_editar && cred_oper && lanc.baixa">
                    <i class="fa-solid fa-link"></i>
                  </a>

                  <a href="#" @click.prevent="ver_uso(lanc)" class="d-print-none" data-toggle="tooltip" data-placement="top" title="Visualizar Uso" v-show="!pode_editar && cred_oper && lanc.baixa && lanc.uso_credito"> <!-- lanc.baixa.fatura_creditos && lanc.baixa.fatura_creditos.length -->
                    <i class="fa-solid fa-eye-slash" v-if="!lanc.ver_uso"></i>
                    <i class="fa-solid fa-eye" v-else></i>
                  </a>
                </template>
              </td>
              <td class="text-center">
                <template v-if="lanc.ch_estado == 'C'">
                  <!-- Cancelado -->
                </template>

                <template v-else>
                  <div v-if="parametros && parametros.natureza == 'O'" class="text-right">
                    <span v-if="lanc.baixa && lanc.uso_credito"> <!-- lanc.baixa.fatura_creditos -->
                      {{ $util.formatMoeda(lanc.liquido - lanc.uso_credito) }} <!-- totalizar(lanc.baixa.fatura_creditos, 'dc_valor') -->
                      <div class="text-muted">
                        Uso: {{ $util.formatMoeda(lanc.uso_credito) }}
                        <!-- Uso: {{ $util.formatMoeda(totalizar(lanc.baixa.fatura_creditos, 'dc_valor')) }} -->
                      </div>
                    </span>
                    <span v-else>
                      {{ $util.formatMoeda(lanc.liquido) }}
                    </span>
                  </div>
                  <!--
                  <div v-else-if="1==0 && lanc.envio && lanc.envio.creditos && lanc.envio.creditos.length" class="text-right">
                    <div v-for="(cred, ibx) in lanc.envio.creditos" :key="ibx" class="d-flex justify-content-between">
                      <div class="text-left mr-3">{{ cred.baixa.conta.st_conta }}</div>
                      <div class="text-right">
                        <i class="fa fa-check-circle text-success" aria-hidden="true" v-if="cred.baixa.fl_conciliado" title="Conciliado"></i>
                        {{ $util.formatMoeda(cred.dc_valor) }}
                      </div>
                    </div>
                  </div>
                  -->
                  <div class="d-print-none" v-else-if="!lanc.baixa || cancelando">
                    <input type="checkbox" v-model="lanc.selecionado" v-if="pode_editar" /> 
                  </div>
                  <div v-else-if="lanc.baixa.conta">
                    <template v-if="parametros && parametros.tipo_data != 'B' && lanc.baixas && lanc.baixas.length">
                      <div v-for="(bxp, ibx) in lanc.baixas" :key="ibx" class="d-flex justify-content-between">
                        <div class="text-left mr-3">{{ bxp.conta.st_conta }}</div>
                        <div class="text-right">
                          <i class="fa fa-check-circle text-success" aria-hidden="true" v-if="bxp.fl_conciliado" title="Conciliado"></i>
                          {{ $util.formatMoeda(bxp.valor_baixa ? bxp.valor_baixa : bxp.valor_liquido) }}
                        </div>
                      </div>
                    </template>

                    <div class="d-flex justify-content-between" v-else>
                      <div class="text-left mr-3">{{ lanc.baixa.conta.st_conta }}</div>
                      <div class="text-right">
                        <i class="fa fa-check-circle text-success" aria-hidden="true" v-if="lanc.baixa.fl_conciliado" title="Conciliado"></i>
                        {{ $util.formatMoeda(lanc.baixa.valor_baixa ? lanc.baixa.valor_baixa : lanc.baixa.valor_liquido) }}
                      </div>
                    </div>

                    <div v-if="lanc.baixado && lanc.baixado.parcial" class="text-center d-print-none">
                      <input type="checkbox" v-model="lanc.selecionado" v-if="pode_editar" /> 
                    </div>
                  </div>

                </template>
              </td>

              <td class="text-right" v-if="parametros && ( parametros.natureza == 'C' || parametros.natureza == 'D' )">
                <span v-if="lanc.baixado">
                  {{ $util.formatMoeda(lanc.baixado.saldo_liq) }}
                </span>
              </td>
            </tr>
            <tr v-if="lanc.ver_uso" :key="'uso' + idx"> 
              <td colspan="9">
                <table class="table table-sm">
                  <thead>
                    <tr>
                      <th>Fatura</th>
                      <th>Recebimento</th>
                      <th class="text-right">Retenções</th>
                      <th class="text-right">Uso</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(cred, icx) in lanc.baixa.fatura_creditos" :key="icx">
                      <td><a href="#" @click.prevent="$util.abrirFatura(cred.id_fatura)" class="card-link">#{{ cred.id_fatura }}</a></td>
                      <td>{{ $util.getFormatDate(cred.dt_recebimento) }}</td>
                      <td class="text-right">{{ $util.formatMoeda(cred.dc_retencoes) }}</td>
                      <td class="text-right">{{ $util.formatMoeda(cred.dc_valor) }}</td>
                    </tr>

                    <tr v-for="(cred, icx) in lanc.lanc_credito_usos" :key="icx">
                      <td>
                        <a href="#" @click.prevent="remover_lancamento_credito(cred)" class="card-link mr-3 text-danger">
                          <i class="fa-solid fa-xmark"></i>  
                        </a>

                        Lanc: #{{ cred.id_lancamento_fatura }}
                      </td>
                      <td></td>
                      <td class="text-right">{{ $util.formatMoeda(cred.dc_retencoes) }}</td>
                      <td class="text-right">{{ $util.formatMoeda(cred.dc_valor) }}</td>
                    </tr>
                  </tbody>
                </table>
              </td>
            </tr>
          </template>
        </tbody>
      </table>

      <pre v-if="false && consolidado" class="alert alert-primary">{{ consolidado }}</pre>
      
    </div>

    <div class="mt-3" v-else>
      <az-empty-state 
        :icon="firstLoad ? 'fas fa-money-check-alt' : 'fas fa-sync-alt'" 
        :msg="firstLoad ? 'Nenhuma lançamento identificado.' : 'Clique no ícone para atualizar a busca.'"
        :action="firstLoad ? '' : 'Buscar'"
        :method="load"></az-empty-state>
    </div>

    <!-- Modal -->
    <div class="modal fade" id="baixaModal" tabindex="-1" role="dialog" aria-labelledby="modelTitleId" aria-hidden="true">
      <div class="modal-dialog modal-xl modal-dialog-scrollable" role="document">
        <div class="modal-content" v-if="baixa">
          <div class="modal-header">
            <h5 class="modal-title">
              <span v-if="baixa.id_baixa">
                Baixa 
                <span class="badge badge-secondary">#{{ baixa.id_baixa }}</span>
              </span>
              <span v-else>
                Registro de Baixa
              </span>
            </h5>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">

            <div class="alert alert-success" v-if="baixa.fl_conciliado">
                <div class="d-flex justify-content-between">
                    <div>
                        <i class="fa fa-check mr-3" aria-hidden="true"></i>
                        Conciliado
                    </div>
                    <div>
                        {{ $util.getFormatDate(baixa.dt_conciliacao) }}
                    </div>
                </div>

                <div v-if="baixa.st_memo_extrato" class="small text-muted">
                    {{ baixa.st_memo_extrato }}
                </div>

                <div class="small text-muted" v-if="baixa.st_conciliacao_fitid || baixa.st_conciliacao_checknum">
                    Conciliação: {{ baixa.st_conciliacao_fitid }} / {{ baixa.st_conciliacao_checknum }}
                </div>
            </div>

            <div class="alert alert-info">
              Lançamento: #{{ baixa.id_lancamento }}
            </div>

            <div class="row mb-3" v-if="!baixa.id_baixa && !baixa.id_item_pagamento_atendimento">
              <div class="col col-12">
                <az-input
                  type="button-group"
                  :optionsList="[
                    { id: 'T', search: 'Total' },
                    { id: 'P', search: 'Parcial' },
                  ]"
                  optionsData="id"
                  v-model="baixa.tipo"
                  @click="trocar_parcial(baixa)" />
              </div>
            </div>

            <div class="row">
              <div class="col col-12 col-md-4">
                <az-input
                  label="Data da Baixa"
                  type="date"
                  required 
                  v-model="baixa.dt_baixa" />
              </div>
              <div class="col col-12 col-md-4">
                <az-input
                    label="Forma de Pagamento"
                    :validate="validate"
                    type="select"
                    optionsMode="aql"
                    service="forma_pagamentos.index"
                    optionsData="id_forma_pagamento"
                    optionsDisplay="search"
                    required
                    v-model="baixa.id_forma_pagamento" />
              </div>
              <div class="col col-12 col-md-4">
                <az-input
                    label="Conta"
                    :validate="validate"
                    type="select"
                    optionsName="contas.index.ativas"
                    optionsMode="aql"
                    service="contas.index"
                    optionsData="id_conta"
                    optionsDisplay="search"
                    :optionsParm="{ ativas: true }"
                    required
                    v-model="baixa.id_conta" />
              </div>
            </div>

            <div class="row">
              <div class="col col-12 col-md-3">
                <az-input
                  label="Valor"
                  :edicao="baixa.tipo == 'P'"
                  :validate="validate"
                  :type="baixa.trocando ? 'number' : 'money'"
                  v-model="baixa.dc_valor" />
              </div>
              <div class="col col-12 col-md-3">
                <az-input
                  icon="fa fa-plus-circle"
                  label="Multa/Juros"
                  :validate="validate"
                  type="money"
                  v-model="baixa.dc_multa_juros" />
              </div>
              <div class="col col-12 col-md-3">
                <az-input
                  label="Tipo de Serviço"
                  optionsData='id'
                  :optionsList=tipos_servico
                  :validate="validate"
                  :type="'select'"
                  v-model="baixa.st_tipo_servico" />
              </div>
              <div class="col col-12 col-md-3">
                <az-input
                  label="Forma de Lançamento"
                  optionsData='id'
                  :optionsList=formas_lancamento
                  :validate="validate"
                  type="select"
                  v-model="baixa.st_forma_lancamento" />
              </div>
            </div>

            <div class="row">
              <div class="col col-12 col-md-4">
                <az-input
                  icon="fa fa-minus-circle"
                  label="Descontos/Taxas"
                  :validate="validate"
                  type="money"
                  v-model="baixa.dc_descontos" />
              </div>
              <div class="col col-12 col-md-4">
                <div v-if="baixa.tipo == 'P'">
                  <small class="form-text text-muted text-nowrap text-truncate">
                    Retenções
                  </small>
                  <div class="input-group mb-3">
                    <label class="form form-control alert-secondary">
                      {{ $util.formatMoeda(retencoes_calculadas) }}
                    </label>
                  </div>
                </div>

                <az-input
                  v-else
                  label="Retenções"
                  :edicao="false"
                  :validate="validate"
                  :type="baixa.trocando ? 'number' : 'money'"
                  v-model="baixa.dc_retencoes" />
              </div>
              <div class="col col-12 col-md-4">
                <small class="form-text text-muted text-nowrap text-truncate">
                  Valor Líquido
                </small>
                <div class="input-group mb-3">
                  <div class="input-group-prepend">
                    <span class="input-group-text" id="basic-addon1">
                      <i class="fas fa-equals"></i>
                    </span>
                  </div>
                  <label class="form form-control alert-secondary">
                    {{ $util.formatMoeda(baixa.dc_valor + baixa.dc_multa_juros - baixa.dc_descontos - ( this.retencoes_calculadas ? this.retencoes_calculadas : baixa.dc_retencoes)) }}
                  </label>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col col-12">
                <az-input
                  label="Observação"
                  :validate="validate"
                  v-model="baixa.st_observacoes" />
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <template v-if="solicitar_cancelar_baixa">
              <div class="input-group mb-0">
                <input type="text" class="form-control" placeholder="Informe o motivo de cancelamento..." v-model="baixa.st_motivo_cancelamento">
                <div class="input-group-append">
                  <button class="btn btn-secondary" type="button" @click="solicitar_cancelar_baixa = false">
                    <i class="fa fa-times" aria-hidden="true"></i>
                  </button>
                  <button class="btn btn-danger" type="button" @click="cancelar_baixa ()">
                    <i class="fa fa-check" aria-hidden="true"></i>
                  </button>
                </div>
              </div>
            </template>

            <template v-else>
              <az-audit-log-button model="baixa" :id="baixa.id_baixa" />
              <button type="button" class="btn btn-outline-secondary" @click="imprimir_recibo()" v-if="baixa.id_baixa">Recibo</button>
              <az-submit color="danger" @click="solicitar_cancelar_baixa = true" v-if="baixa.id_baixa && ( !baixa.fatura_creditos || !baixa.fatura_creditos.length ) && !baixa.fl_conciliado">Cancelar Baixa</az-submit>
              <button type="button" class="btn btn-secondary" data-dismiss="modal">Fechar</button>
              <az-submit @click="baixar ()" v-if="!baixa.fl_conciliado">Atualizar</az-submit>
            </template>
          </div>
        </div>
      </div>
    </div>

    <!-- Modal -->
    <div class="modal fade" id="baixaMultiplaModal" tabindex="-1" role="dialog" aria-labelledby="modelTitleId" aria-hidden="true">
      <div class="modal-dialog modal-xl" role="document">
        <div class="modal-content" v-if="baixa_multipla">
          <div class="modal-header">
            <h5 class="modal-title">Baixa Múltipla</h5>
              <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">&times;</span>
              </button>
          </div>
          <div class="modal-body">
            <div class="row">
              <div class="col col-12 col-md-3">
                <az-input
                  type="date"
                  label="Data"
                  :validate="validate"
                  required
                  v-model="baixa_multipla.dt_baixa" />
              </div>
              <div class="col col-12 col-md-1">
                <az-input
                  type="checkbox"
                  label="Unificada"
                  :validate="validate"
                  v-model="baixa_multipla.unificada" />
              </div>
              <div class="col col-12 col-md-5">
                <az-input
                  label="Descrição"
                  placeholder="(Opcional)..."
                  :validate="validate"
                  :edicao="baixa_multipla.unificada"
                  v-model="baixa_multipla.st_descricao" />
              </div>
              <div class="col col-12 col-md-3">
                <az-input
                  label="Conta"
                  :validate="validate"
                  type="select"
                  optionsMode="aql"
                  optionsName="contas.index.ativas"
                  service="contas.index"
                  optionsData="id_conta"
                  optionsDisplay="search"
                  :optionsParm="{ ativas: true }"
                  required
                  v-model="baixa_multipla.id_conta" />
              </div>
            </div>
            <div class="row">
              <div class="col col-12 col-md-3">
                <az-input
                  label="Valor"
                  type="money"
                  :edicao="false"
                  required
                  v-model="baixa_multipla.dc_valor" />
              </div>
              <div class="col col-12 col-md-3">
                <az-input
                  label="Retenções"
                  type="money"
                  :edicao="false"
                  required
                  v-model="baixa_multipla.dc_retencoes" />
              </div>
              <div class="col col-12 col-md-3">
                <az-input
                  label="Taxas/Descontos"
                  :edicao="false"
                  :value="$util.formatMoeda(total_bm_taxas)" />
              </div>
              <div class="col col-12 col-md-3">
                <az-input
                  label="Líquido"
                  :edicao="false"
                  :value="$util.formatMoeda(total_bm_liquido)" />
              </div>
            </div>

            <div class="card mt-3">
              <div class="card-header d-flex justify-content-between">
                <div>
                  <a href="#" @click.prevent="baixa_multipla.expandido = !baixa_multipla.expandido" class="card-link">
                    Lançamentos
                  </a>
                </div>
                <div>
                  <span class="badge badge-secondary" title="Quantidade de lançamentos.">
                    {{ baixa_multipla.lancamentos.length }}
                  </span>
                </div>
              </div>
              <ul class="list-group" v-show="baixa_multipla.expandido">
                <li class="list-group-item" v-for="(lanc, ilx) in baixa_multipla.lancamentos" :key="ilx">
                  <div class="row" >
                    <div class="col col-12 col-md-8 small">
                      {{ lanc.st_descricao }}
                      <div class="text-muted">
                        Emissão: {{ $util.getFormatDate(lanc.dt_emissao) }} 
                        <i class="fa fa-caret-right mx-3" aria-hidden="true"></i>
                        Venc: {{ $util.getFormatDate(lanc.dt_vencimento) }}
                      </div>
                    </div>
                    <div class="col col-12 col-md-2 text-right">
                      <span v-if="lanc.baixado && lanc.baixado.parcial">{{ $util.formatMoeda(lanc.baixado.saldo) }} /</span>
                      {{ $util.formatMoeda(lanc.dc_valor) }}
                      <div class="small text-muted" v-if="lanc.taxa > 0">
                        {{ $util.formatMoeda(lanc.dc_valor - lanc.taxa) }}
                      </div>
                    </div>
                    <div class="col col-12 col-md-2">
                      <az-input
                        label="Taxa/Desconto"
                        type="money"
                        sizing="sm"
                        :mb="false"
                        :mt="false"
                        v-model="lanc.taxa">
                      </az-input>
                    </div>
                  </div>
                </li>
              </ul>
            </div>

            <pre v-if="false">{{ baixa_multipla }}</pre>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" data-dismiss="modal">Cancelar</button>
            <az-submit @click="baixar_multipla ()">Realizar</az-submit>
          </div>
        </div>
      </div>
    </div>

    <!-- Modal -->
    <div class="modal fade" id="cancelamentosModal" tabindex="-1" role="dialog" aria-labelledby="modelTitleId" aria-hidden="true">
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">Excluir Lançamentos</h5>
              <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">&times;</span>
              </button>
          </div>
          <div class="modal-body">
            <div class="lead">{{ selecionados.length }} {{ selecionados.length > 1 ? 'lançamentos' : 'lançamento' }}</div>
            <div class="lead">R$ {{ $util.formatMoeda (total_selecionado) }}</div>
            <div class="row" v-if="1 == 0">
              <div class="col col-12">
                <az-input
                  label="Motivo do Cancelamento"
                  required
                  v-model="motivo_cancelamentos" />
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" data-dismiss="modal">Fechar</button>
            <az-submit color="danger" @click="confirmar_cancelar_lancamentos ()">Confirmar</az-submit>
          </div>
        </div>
      </div>
    </div>

    <!-- Baixa Parcial Modal -->
    <div class="modal fade" id="baixaParcialModal" tabindex="-1" role="dialog" aria-labelledby="modelTitleId" aria-hidden="true">
      <div class="modal-dialog modal-xl modal-dialog-scrollable" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">Baixas</h5>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <template v-if="!baixas">
              <az-empty-state />
            </template>

            <template v-else>
              <table class="table">
                <thead>
                  <tr>
                    <th>Id</th>
                    <th>Data</th>
                    <th>Conta</th>
                    <th>Observação</th>
                    <th class="text-right">Valor</th>
                    <th class="text-right">Retenção</th>
                    <th class="text-right">Líquido</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(bxp, ibx) in baixas.baixas" :key="ibx">
                    <td>
                      <a href="#" @click.prevent="registrar_baixa(baixas, bxp)" class="card-link">
                        #{{ bxp.id_baixa }}
                      </a>
                      <i class="fa fa-check-circle text-success" aria-hidden="true" title="Conciliado" v-if="bxp.fl_conciliado"></i>
                    </td>
                    <td>
                      {{ $util.getFormatDate(bxp.dt_baixa) }}
                    </td>
                    <td>
                      {{ bxp.conta.search }}
                    </td>
                    <td>
                      {{ bxp.st_observacoes }}
                    </td>
                    <td class="text-right">
                      {{ $util.formatMoeda(bxp.dc_valor) }}
                    </td>
                    <td class="text-right">
                      {{ $util.formatMoeda(bxp.dc_retencoes) }}
                    </td>
                    <td class="text-right">
                      {{ $util.formatMoeda(bxp.valor_liquido) }}
                    </td>
                  </tr>
                </tbody>
                <tfoot>
                  <tr class="table-info">
                    <td colspan="4">
                      Total Baixado
                    </td>
                    <td class="text-right">
                      {{ $util.formatMoeda(totalizar(baixas.baixas, 'dc_valor')) }}
                    </td>
                    <td class="text-right">
                      {{ $util.formatMoeda(totalizar(baixas.baixas, 'dc_retencoes')) }}
                    </td>
                    <td class="text-right">
                      {{ $util.formatMoeda(totalizar(baixas.baixas, 'valor_liquido')) }}
                    </td>
                  </tr>
                  <tr class="table-secondary">
                    <td colspan="4">
                      Total Lançamento
                    </td>
                    <td class="text-right">
                      {{ $util.formatMoeda(baixas.valor_md) }}
                    </td>
                    <td class="text-right">
                      {{ $util.formatMoeda(baixas.valor_retencoes) }}
                    </td>
                    <td class="text-right">
                      {{ $util.formatMoeda(baixas.liquido) }}
                    </td>
                  </tr>
                  <tr class="table-danger" v-if="baixas.baixado.parcial">
                    <td colspan="4">
                      Saldo
                    </td>
                    <td class="text-right">
                      {{ $util.formatMoeda(baixas.valor_md - totalizar(baixas.baixas, 'dc_valor')) }}
                    </td>
                    <td class="text-right">
                      {{ $util.formatMoeda(baixas.valor_retencoes - totalizar(baixas.baixas, 'dc_retencoes')) }}
                    </td>
                    <td class="text-right">
                      {{ $util.formatMoeda(baixas.liquido - totalizar(baixas.baixas, 'valor_liquido')) }}
                    </td>
                  </tr>
                </tfoot>
              </table>
            </template>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" data-dismiss="modal">Fechar</button>
            <button type="button" class="btn btn-success" v-if="baixas && baixas.baixado.parcial" @click="registrar_baixa(baixas, null, true)">
              Registrar Baixa
            </button>
          </div>
        </div>
      </div>
    </div>

    <br><br><br><br><br>

    <nav class="navbar fixed-bottom navbar-light bg-light" v-if="selecionados && selecionados.length > 0">
        <div class="navbar-brand">
          Total Selecionado: R$ {{ $util.formatMoeda (total_selecionado) }}
        </div>
        <div class='mr-3' v-if="!cancelando"> 
            <button class="btn btn-sm ml-1" :class="apenas_selecionados ? 'btn-primary' : 'btn-outline-primary'" type="button" @click="apenas_selecionados = !apenas_selecionados">
              {{ apenas_selecionados ? 'Exibir Todos' : 'Filtrar Selecionados' }}
            </button>
            <button class="btn btn-danger btn-sm ml-1" type="button" @click="cancelar_lancamentos ()">
              Excluir
            </button>
            <button class="btn btn-success btn-sm ml-1" type="button" @click="registrar_baixa_multipla ()"
              :disabled="selecionados.length < 2">
              Dar Baixa
            </button>
        </div>
        <div class='mr-3' v-else> 
            <button class="btn btn-danger btn-sm ml-1" type="button" @click="cancelar_baixas ()">
                Cancelar Baixas
            </button>
        </div>
    </nav>

    <!-- Paginação -->
    <nav class="navbar fixed-bottom navbar-light bg-light pb-3" v-else-if="dados && dados.last_page > 1">
        <div class="d-flex">
            <paginate
                class="mb-0"
                :page-count="dados.last_page"
                :container-class="'pagination'"
                :page-class="'page-item'"
                :page-link-class="'page-link'"
                :prev-class="'page-link'"
                :next-class="'page-link'"
                :prev-text="'<<'"
                :next-text="'>>'"
                :click-handler="paginar">
            </paginate>
        </div>
    </nav>

    <une-cont ref="unecont" />

    <!-- Lançamento -->
    <edicao-lancamento ref="lancamento" :conta_ad="conta_ad" :unidade="filtro.id_unidade_operacao" @refresh="load()" />

    <!-- Transferir Crédito -->
    <transferir-baixa-credito-de-operadora ref="transf_cred" @refresh="load()" />

    <!-- Envio de Arquivo -->
    <template v-if="acao_anexar && item">
      <az-file-upload
        ref="upload"
        @refresh="carregar_arquivos()"
        :multiple="true"
        :arquivos="item.arquivos"
        :anexar_mult="item.in_total_parcelas > 1"
        :parms="{ model_type: 'lancamento', model_id: item.id_lancamento }"
        :viewonly="!pode_editar" />
    </template>

  </div>
</template>

<script>
import $ from 'jquery';
import _ from 'lodash';
import * as moment from "moment";
import AzSubmit from '../../util/AzSubmit.vue';
import AzInput from '../../shared/forms/AzInput.vue';
import AzEmptyState from '../../util/AzEmptyState.vue';
import AzAuditLogButton from '../../util/AzAuditLogButton.vue';
import PrintExport from '../../shared/PrintExport.vue';
import EdicaoLancamento from './EdicaoLancamento.vue';
import AzFileUpload from '../../util/AzFileUpload.vue';
import AzPeriodo from '../../shared/forms/AzPeriodo.vue';
import Importacao from '../../cadastros/shared/Importacao.vue';
import TableTh from '../../shared/table/TableTh.vue';
import LancamentoNotaFiscalInfo from './LancamentoNotaFiscalInfo.vue';
import TransferirBaixaCreditoDeOperadora from './TransferirBaixaCreditoDeOperadora.vue';
import UneCont from './UneCont.vue';

export default {
  data() {
    return {
      dados: null, 
      parametros: null, 
      item: null, 
      validate: false,
      referencia: null, 
      from: "", 
      to: "",
      baixa: null, 
      baixas: null, 
      baixa_multipla: null, 
      cancelando: false, 
      filtro: { 
        id_forma_pagamento: "",
        id_fornecedor: "", 
        id_operadora: "",
        search: "", 
        natureza: "", 
        status: "", 
        id_unidade_operacao: "", 
        id_centro_custo: "", 
        periodo: "do",
        inicio: null,
        fim: null, 
        tipo_data: "", 
        id_categoria: "", 
        conciliado: false,   
        retroativo: false,       
      },
      solicitar_cancelar_baixa: false, 
      motivo_cancelamentos: "", 
      acao_anexar: false, 
      montando: true, 
      conta_ad: null, 
      page: 1, 
      firstLoad: false, 
      ordem: "", 
      apenas_selecionados: false, 
      acesso_edicao: false, 
      show_obs: false, 
      tipos_servico: [],
      formas_lancamento: [],
      consolidado: null,
      filtro_operadora: null, 
    };
  },

  props: ['parms', 'block_redir', 'view', 'fluxo', 'cred_oper'],

  components: { 
    AzSubmit,
    AzInput, 
    AzEmptyState, 
    AzAuditLogButton, 
    PrintExport,
    EdicaoLancamento, 
    AzFileUpload,
    AzPeriodo, 
    Importacao, 
    TableTh,
    LancamentoNotaFiscalInfo, 
    TransferirBaixaCreditoDeOperadora, 
    UneCont, 
  },

  computed: { 
    parms_relat_linkados: function () { 
        return { 
            lancamento_id: this.dadosFormatados.map(lanc => lanc.id),
        };
    },

    lista_centro_custo: function () { 
        if ( !this.filtro.id_unidade_operacao )
            return [];

        let unidade = this.$store.state.unidade.unidade_operacaos
            .find(item => item.id_unidade_operacao == this.filtro.id_unidade_operacao);

        if ( unidade )
            return unidade.centro_custos;

        return [];
    },

    pode_editar: function () { 
      return !this.view && this.acesso_edicao && ( !this.parametros || !this.parametros.dt_retroativo );
    },

    total_bm_taxas: function () { 
      if ( !this.baixa_multipla || !this.baixa_multipla.lancamentos )
        return 0;

      let valor = this.baixa_multipla.lancamentos.reduce((total, item) => { 
        return total + parseFloat(item.taxa);
      }, 0);

      return Math.round(valor * 100) / 100;
    },

    total_bm_liquido: function () { 
      return this.total_selecionado - this.total_selecionado_retencoes - this.total_bm_taxas;
    },

    dadosFormatados: function () { 
  
      return this.lista.map(lanc => { 
        let item = { 
          id: lanc.id_lancamento, 
          emissao: this.$util.getFormatDate(lanc.dt_emissao),
          vencimento: this.$util.getFormatDate(lanc.dt_vencimento),
          descricao: ( lanc.ch_tipo_lancamento == 'T' ? ( lanc.conta_origem.search + ' para ' + lanc.conta_destino.search ) : lanc.st_descricao ),
          competencia: this.$util.getFormatDate(lanc.dt_competencia, 'MM/YYYY'),
          categoria: lanc.categoria 
            ? lanc.categoria.st_categoria
            : ( lanc.categorias ? lanc.categorias : ( lanc.ch_tipo_lancamento == 'T' ? 'Transferência' : ( lanc.ch_tipo_lancamento == 'M' ? 'Adiantamento' : '' ) ) ),
          valor: this.$util.formatMoeda(lanc.dc_valor),
          desconto_lancamento: lanc.dc_descontos ? this.$util.formatMoeda(lanc.dc_descontos) : 0,
          multa_juros_lancamento: lanc.dc_multa_juros ? this.$util.formatMoeda(lanc.dc_multa_juros) : 0,
          fator: ( lanc.ch_tipo_lancamento == 'D' || lanc.ch_tipo_lancamento == 'M' ) ? -1 : ( lanc.ch_tipo_lancamento == 'T' ? 0 : 1 ), 
          baixado: lanc.baixa ? 'Sim' : 'Não',
          conta: lanc.baixa && lanc.baixa.conta ? lanc.baixa.conta.st_conta : '',
          liquido: lanc.baixa && lanc.baixa.conta ? this.$util.formatMoeda(lanc.baixa.valor_liquido) : this.$util.formatMoeda(lanc.liquido), 
          fornecedor: lanc.fornecedor ? lanc.fornecedor.search : '', 
          classificacao: lanc.js_classes,
          obs: lanc.st_observacoes,
          doc: lanc.st_doc,
          unidade: lanc.unidade_operacao
            ? ( lanc.unidade_operacao.st_sigla ? lanc.unidade_operacao.st_sigla : lanc.unidade_operacao.st_nome )
            : '',
          data_baixa: lanc.baixa ? this.$util.getFormatDate(lanc.baixa.dt_baixa) : '', 
          centro_custo: lanc.centro 
            ? lanc.centro.st_nome 
            : ( lanc.centros 
              ? lanc.centros.map(centro => centro.centro_custo ? centro.centro_custo.st_nome : '').join(', ')
              : '' 
            ),
          conciliado: ( lanc.baixa && lanc.baixa.fl_conciliado ) ? 'S' : 'N',
          data_conciliacao: ( lanc.baixa && lanc.baixa.fl_conciliado ) ? this.$util.getFormatDate(lanc.baixa.dt_conciliacao) : '', 
          parcela: lanc.in_parcela,
          parcelas: lanc.in_total_parcelas,
          transf: lanc.ch_tipo_lancamento == 'T' ? 'S' : 'N', 
          categoria_cod_externo: lanc.categoria ? lanc.categoria.st_codigo_externo : '',
        };

        if ( this.parametros && this.parametros.natureza == 'O' ) { 
          item.uso_credito = this.$util.formatMoeda(lanc.uso_credito ? lanc.uso_credito : 0);
        }

        return item; 
      });

    },

    lista: function () { 
      if ( !this.dados )
        return [];

      let pesquisar = this.filtro.search.trim();
      let parts = pesquisar.replace(' ','.*');
      let match = parts;
      let reg = new RegExp(match, 'i');

      return _.orderBy(
        this.dados.data.filter(item => { 
          return ( !this.filtro.id_fornecedor || item.id_fornecedor == this.filtro.id_fornecedor ) && 
            ( !this.filtro.id_forma_pagamento || item.id_forma_pagamento == this.filtro.id_forma_pagamento ) && 
            ( !this.filtro.natureza || ( this.filtro.natureza != 'C' && this.filtro.natureza != 'D' ) 
              || ( item.categoria && item.categoria.ch_natureza == this.filtro.natureza ) 
              || ( item.centros && item.centros.find(centro => centro.categoria && centro.categoria.ch_natureza == this.filtro.natureza) )  
              || ( this.filtro.natureza == 'D' && item.ch_tipo_lancamento == 'M' ) ) && 
            ( !this.cancelando || item.baixa ) && 
            ( !this.apenas_selecionados || item.selecionado ) &&
            ( !this.filtro_operadora || item.id_operadora == this.filtro_operadora.id_operadora ) && 
            ( !this.filtro.search || reg.test(JSON.stringify(item)) );

            // ( !this.filtro.status || this.filtrar_status (item, this.filtro.status) ) &&
        }),
        this.ordem ? this.ordem.name : 'dt_vencimento',
        this.ordem ? this.ordem.direction : 'asc',
      );
    },

    selecionados: function () { 
      let teste = _.uniqBy(this.lista.filter(item => item.selecionado), lanc => lanc.ch_tipo_lancamento == 'A' ? 'C' : lanc.ch_tipo_lancamento).length;

      if ( teste > 1 )
        return [];

      return this.lista.filter(item => item.selecionado);
    },

    total_selecionado: function () { 
      return this.selecionados.reduce((total, item) => { 
        return total = total + ( item.baixado ? item.baixado.saldo : item.dc_valor ); 
      }, 0);
    },

    natureza_unica: function () { 
      return _.uniqBy(this.lista, 'ch_tipo_lancamento').length == 1;
    },

    total_selecionado_retencoes: function () { 
      return this.selecionados.reduce((total, item) => { 
        return total = total + parseFloat(item.valor_retencoes) - ( item.baixado ? item.baixado.retencoes : 0 ); 
      }, 0);
    },

    total_lancamentos: function () { 
      return this.lista.reduce((total, item) => { 
        return total = total + parseFloat(item.dc_valor); 
      }, 0);
    },

    total_lancamentos_sem_adiant: function () { 
      return this.lista.reduce((total, item) => { 
        return total = total + parseFloat(item.liquido); 
      }, 0);
    },

    total_saldo_liq: function () { 
      return this.lista.reduce((total, item) => { 
        return total = total + ( item.baixado ? parseFloat(item.baixado.saldo_liq) : 0 ); 
      }, 0);
    },

    total_baixas: function () { 
      return this.lista.reduce((total, item) => { 
        return total = total + ( ( item.baixa && item.id_baixa ) 
          ? ( item.valor_baixa ? item.valor_baixa : item.baixa.valor_liquido ) 
          : ( item.baixas 
            ? item.baixas.reduce((tb, cb) => { 
                return tb + ( cb.valor_baixa ? cb.valor_baixa : cb.valor_liquido );
              }, 0) 
            : 0 ) ); 
      }, 0);
    },

    total_saldo_creditos: function () { 
      return this.lista.reduce((total, item) => { 
        return total = total + item.liquido 
          - ( ( item.baixa && item.uso_credito ) 
              ? item.uso_credito 
              : 0 
          ); 
      }, 0);

      /*
      return this.lista.reduce((total, item) => { 
        return total = total + item.liquido 
          - ( ( item.baixa && item.baixa.fatura_creditos ) 
              ? this.totalizar(item.baixa.fatura_creditos, 'dc_valor') 
              : 0 
          ); 
      }, 0);
      */
    },

    total_uso_creditos: function () { 
      return this.lista.reduce((total, item) => { 
        return total = total + ( ( item.baixa && item.uso_credito ) // item.baixa.fatura_creditos
              ? item.uso_credito // this.totalizar(item.baixa.fatura_creditos, 'dc_valor') 
              : 0 
          ); 
      }, 0);
    },

    retencoes_calculadas: function () { 
      if ( !this.baixa || !this.baixa.dc_retencoes_original || !this.baixa.dc_valor_original )
        return 0;

      return Math.round(
          this.baixa.dc_retencoes_original * ( this.baixa.dc_valor / this.baixa.dc_valor_original ) * 100
        ) / 100;
    }

  },

  methods: { 
    abrir_unecont () { 
        this.$refs.unecont.abrir();
    },

    remover_lancamento_credito (cred) { 
      if ( !confirm('Confirma remover o crédito do lançamento?') ) { 
        return;
      }

      this.$util.atualizar(this, { 
        service: 'financeiro',
        func: 'lancamento_vinculo_credito_remover', 
        dados: { 
          id_lancamento_credito: cred.id_lancamento_credito, 
        },
        toast: true, 
        reload: true, 
      });
    },

    transferir_baixa_credito (lancamento) { 
      this.$refs.transf_cred.abrir(lancamento);
    },

    ver_uso (lanc) { 
      $('[data-toggle="tooltip"]').tooltip("dispose");
      lanc.ver_uso = !lanc.ver_uso;
    },

    imprimir_recibo () { 
      if ( this.baixa && this.baixa.id_baixa ) { 
        $('.modal').modal('hide');

        this.$nextTick(() => { 
          this.$util.print_preview('imprimir/recibo/' + this.baixa.id_baixa, true);
        });
      }
    },

    toggle_cancelando () { 
      if ( this.selecionados && this.selecionados.length > 0 ) { 
        this.marcar_todos();
      }

      this.$nextTick(() => { 
        this.cancelando = !this.cancelando;
      });
    },

    trocar_parcial(baixa) { 
      
      baixa.trocando = true; 

      this.$nextTick(() => { 
        baixa.dc_valor = baixa.dc_valor_original;
        baixa.dc_retencoes = baixa.dc_retencoes_original;
        baixa.trocando = false; 
      });
      
    },

    totalizar (lista, campo) { 
      if ( !lista.length )
        return 0;

      return lista.reduce((total, carry) => { 
        return total + parseFloat(carry[campo]);
      }, 0);
    },

    paginar (page) {
        this.page = page;
        this.load(false);
    },

    filtrar(texto) { 
      if ( !texto ) { 
        this.filtro.search = "";
        return;
      }

      const pesq = '"' + texto + '"';

      this.filtro.search = ( pesq == this.filtro.search ) ? "" : pesq; 
    },

    ajustar_fim () { 
        if ( this.from )
            this.to = this.from;
    },
    abrir_anexar_arquivo(item) { 
      this.item = item;

      if ( this.item.arquivos && this.item.arquivos.length && !this.item.arquivos.find(arq => arq.arquivo) ) { 
        this.item.carregando = true; 

        this.carregar_arquivos(true);

      } else { 

        this.acao_anexar = true;

        this.$nextTick(() => { 
          this.$refs.upload.abrir();
        });
        
      }

    },

    carregar_arquivos (abrir = false) { 

      this.$store.commit('loading', true);

      this.$util.loadItem(this, { 
        service: 'financeiro',
        func: 'show',
        parms: { 
          id: this.item.id_lancamento,
        },
      })
      .then(res => { 
        this.item.arquivos = res.arquivos;
        this.acao_anexar = true;

        if ( abrir ) { 
          this.$nextTick(() => { 
            this.$refs.upload.abrir();
          });
        }
      })
      .finally(() => { 
        this.item.carregando = false; 
        this.$store.commit('loading', false);
      });

    },

    marcar_todos() { 

      let tipo = "";

      if ( this.cancelando ) { 

        let marcar = !( this.lista.findIndex(item => ( item.baixa ) && item.selecionado) >= 0 ) ;

        this.lista.filter(item => item.baixa && item.ch_estado != 'C')
        .forEach(element => {
          if ( !tipo )
            tipo = element.ch_tipo_lancamento;

          if ( tipo == element.ch_tipo_lancamento ) 
            element.selecionado = marcar;
        });

      } else { 
        let marcar = !( this.lista.findIndex(item => ( !item.baixa ) && item.selecionado) >= 0 ) ;

        this.lista.filter(item => !item.baixa && item.ch_estado != 'C')
        .forEach(element => {
          if ( !tipo )
            tipo = element.ch_tipo_lancamento;

          if ( tipo == element.ch_tipo_lancamento ) 
            element.selecionado = marcar;
        });
      }

    },

    filtrar_status (item, status) { 
      if ( status == 'A' && item.baixa )
        return false;
      else if ( status == 'F' && !item.baixa )
        return false;
      else if ( status == 'T' && ( item.baixa || item.dt_vencimento >= this.$util.hoje () ) )
        return false;

      return true;
    },

    cancelar_lancamentos () { 
      this.motivo_cancelamentos = "";
      $('#cancelamentosModal').modal('show');
    },

    carregar_recorrencia (id) { 

      $('.modal').modal('hide');

      this.$util.load(this, { 
        service: 'financeiro',
        parms: { 
          id_recorrencia: id, 
          size: 1000, 
          cred_oper: this.cred_oper,
        },
        page: 1, 
        loadTo: res => { 
          this.dados = res.lancamentos;
          this.conta_ad = res.adiantamento;
          this.parametros = null;
        }
      });

    },

    carregar_baixa_multipla (lanc) { 

      $('.modal').modal('hide');

      this.$util.load(this, { 
        service: 'financeiro',
        parms: { 
          id_baixa_multipla: lanc.baixa.id_baixa_multipla, 
          size: 1000, 
          cred_oper: this.cred_oper,
        },
        page: 1, 
        loadTo: res => { 
          this.dados = res.lancamentos;
          this.conta_ad = res.adiantamento;
          this.parametros = null;
        }
      });

    },

    cancelar_baixa () { 

      this.$util.atualizar (this, { 
        service: 'financeiro',
        func: 'cancelar_baixa',
        dados: this.baixa,
        modal: 'baixaModal',
        reload: true, 
      });

    },

    confirmar_cancelar_lancamentos () { 

      this.$util.atualizar (this, { 
        service: 'financeiro',
        func: 'destroy',
        dados: { 
          lancamentos: this.selecionados.map(item => { return { id_lancamento: item.id_lancamento }; }),
        },
        modal: 'cancelamentosModal',
        reload: true, 
      });

    },

    registrar_baixa_multipla () { 

      this.baixa_multipla = null;

      let lista = _.cloneDeep(this.selecionados);

      lista.forEach(item => { 
        item.taxa = this.calcular_taxa (item);
        item.calc_taxa = true;
      });

      /*
      let taxas = lista.reduce((total, item) => { 
        return total + item.taxa;
      }, 0);
      */

      this.$nextTick (() => { 
        this.baixa_multipla = { 
          dt_baixa: this.$util.hoje(),
          dc_valor: this.total_selecionado,
          dc_retencoes: this.total_selecionado_retencoes, 
          dc_taxas: this.total_bm_taxas, 
          liquido: this.total_selecionado - this.total_selecionado_retencoes - this.total_bm_taxas,
          id_conta: "", 
          expandido: false, 
          lancamentos: lista, 
          unificada: true, 
        };

        this.validate = false;
        $('#baixaMultiplaModal').modal('show');
      });

    },
    
    calcular_taxa(lancamento) { 

      if ( !lancamento.bandeira_cartao || !lancamento.bandeira_cartao.por_unidade )
        return 0;

      let taxa = ( lancamento.bandeira_cartao.por_unidade.dc_taxa / 100 );
      let parcelas = _.get(lancamento, 'item_pagamento_atendimento.in_parcelas');

      if ( parcelas > 1 && lancamento.bandeira_cartao.por_unidade.bandeira_cartao_parcelas ) { 
        
        let parcela = lancamento.bandeira_cartao.por_unidade.bandeira_cartao_parcelas.find(elem => { 
          return elem.in_parcela_min <= parcelas && ( !elem.in_parcela_max || elem.in_parcela_max >= parcelas );
        });

        if ( parcela ) { 
          taxa = ( parcela.dc_taxa / 100 );
        }

      }

      return lancamento.dc_valor * taxa;

    },

    registrar_baixa (item, baixa_selec = null, baixar_saldo = false) { 
      if ( this.view || !this.acesso_edicao )
        return;

      $('.modal').modal('hide');

      this.baixa = null;
      this.baixas = null;
      this.validate = false;
      this.solicitar_cancelar_baixa = false;
      
      this.$nextTick(() => { 

        if ( baixa_selec ) {

          this.baixa = _.cloneDeep(baixa_selec);

        } else if ( !baixar_saldo && item.baixado && ( item.baixado.parcial || item.baixas.length > 1 ) ) { 

          $('#baixaParcialModal').modal('show');

          this.$util.load(this, { 
              service: 'financeiro',
              func: 'show',
              parms: { 
                  id: item.id_lancamento, 
              },
              loadTo: res => { 
                this.baixas = _.cloneDeep(res);
              }
          });

          return;
    
        } else if ( !baixar_saldo && item.baixa ) { 

          this.baixa = _.cloneDeep(item.baixa);

        } else { 

          /*
          switch (item.ch_estado) {
            case 'C':
              this.$toast.add({
                severity: "error",
                summary: "Atenção",
                detail: 'Lançamento cancelado não pode ser baixado.',
                life: 3000
              });
              return;

            case 'R':
              this.$toast.add({
                severity: "error",
                summary: "Atenção",
                detail: 'Lançamento reprogramado não pode ser baixado.',
                life: 3000
              });
              return;
          }
          */

          let baixa = {
            id_baixa: null, 
            id_conta: "", 
            id_forma_pagamento: item.id_forma_pagamento, 
            id_lancamento: item.id_lancamento, 
            dt_baixa: this.$util.hoje(), 
            dc_valor_original: baixar_saldo ? item.baixado.saldo : item.valor_md, 
            dc_valor: baixar_saldo ? item.baixado.saldo : item.valor_md,
            dc_multa_juros: 0,
            dc_descontos: 0, 
            fl_ativa: true, 
            st_observacoes: "", 
            st_motivo_cancelamento: "", 
            dc_retencoes_original: item.valor_retencoes 
              - ( baixar_saldo ? item.baixado.retencoes : 0 ),
            dc_retencoes: item.valor_retencoes 
              - ( baixar_saldo ? item.baixado.retencoes : 0 ),
            tipo: "T", 
            trocando: false, 
            baixar_saldo: baixar_saldo, 
            id_item_pagamento_atendimento: item.id_item_pagamento_atendimento,
          };

          if ( item.categoria && item.categoria.ch_natureza == 'C' && item.id_bandeira_cartao ) { 

            console.log('item bandeira', item);

            this.$util.loadItem(this, { 
              service: 'bandeira_cartaos',
              id: item.id_bandeira_cartao, 
            })
            .then(cartao => { 

              baixa.dc_descontos = baixa.dc_valor * ( cartao.por_unidade.dc_taxa / 100 );

              let parcelas = _.get(item, 'item_pagamento_atendimento.in_parcelas');
              
              if ( parcelas > 1 && cartao.por_unidade.bandeira_cartao_parcelas ) { 
                
                let parcela = cartao.por_unidade.bandeira_cartao_parcelas.find(elem => { 
                  return elem.in_parcela_min <= parcelas && ( !elem.in_parcela_max || elem.in_parcela_max >= parcelas );
                });

                if ( parcela ) { 
                  baixa.dc_descontos = baixa.dc_valor * ( parcela.dc_taxa / 100 );
                }

              }

              this.baixa = baixa;
              abrir();
            });

            return;

          } else { 

            this.baixa = baixa;

          }

        }

        abrir();

      });

      function abrir() { 
        $('#baixaModal').modal('show');
      }

    },

    incluir () { 

      if ( this.view ) { 
        return;
      }

      if ( !this.acesso_edicao ) { 
        this.$toast.add({
          severity: "error",
          summary: "Atenção",
          detail: 'Acesso disponível apenas para consulta no financeiro. (#133)',
          life: 3000
        });
        return;
      }

      this.$refs.lancamento.incluir ();

    },

    editar (item) { 
      if ( this.view ) { 
        return;
      }

      this.$refs.lancamento.editar(item);
    },

    baixar () {

      if ( this.view ) { 
        return;
      }
      
      if ( this.baixa.tipo == 'P' && this.retencoes_calculadas ) { 
        this.baixa.dc_retencoes = this.retencoes_calculadas;
      }

      this.$util.atualizar (this, { 
        service: 'financeiro',
        func: 'baixar',
        dados: this.baixa,
        modal: 'baixaModal',
        reload: true, 
      });

    },

    baixar_multipla () { 

      this.$util.atualizar (this, { 
        service: 'financeiro',
        func: 'baixar_multipla',
        dados: { 
          ...this.baixa_multipla,
        },
        modal: 'baixaMultiplaModal',
        reload: true, 
      });

    },

    atualizar () { 
      let dados = { ...this.item };
      dados.dt_competencia = dados.dt_competencia.substr (0,7);

      this.$util.atualizar (this, { 
        service: 'financeiro',
        dados: dados, 
        modal: 'lancamentoModal', 
        reload: true, 
      });
    },

    load () { 
      if ( this.montando )
        return;

      if ( this.referencia ) { 
        if ( !this.from || !this.to || this.from > this.to ) { 
          this.dados = null;
          this.consolidado = null;
          return;
        }
      }

      this.cancelando = false;
      this.apenas_selecionados = false;

      this.$util.load(this, { 
        service: 'financeiro',
        parms: { 
          lista: true, 
          from: this.from,
          to: this.to, 
          compet: this.referencia, 
          ...this.filtro,
          cred_oper: this.cred_oper,
          size: 1000, 
        },
        page: this.page,
        loadTo: res => { 
          this.dados = res.lancamentos;
          this.consolidado = res.consolidado;
          this.conta_ad = res.adiantamento;
          this.parametros = res.parametros;

          // Tratamento para o caso de valor distribuido (centros).
          if ( this.filtro.id_categoria && ( this.filtro.tipo_data == 'B' || this.filtro.status == 'F' ) ) { 
            this.dados.data.map(item => { 
              if ( item.valor_liquido ) {
                item.liquido = item.valor_liquido;
              }

              /*
              if ( item.valor_baixa && item.baixa ) { 
                item.baixa.valor_liquido = item.valor_baixa;
              }

              if ( item.baixas && item.baixas.length ) { 
                item.baixas = item.baixas.map(baixa => { 
                  if ( baixa.valor_baixa ) { 
                    baixa.valor_liquido = baixa.valor_baixa;
                  }

                  return baixa;
                });
              }
              */

              return item;
            });
          }
          //

          if ( this.page > 1 && res.lancamentos.last_page < res.lancamentos.current_page ) { 
            this.page = 1;

            this.$nextTick(() => { 
              this.load();
            });
          }
        }
      });

      this.firstLoad = true;
    },

    preencher_parms (parms) { 

      this.referencia = this.$util.hoje().substr(0,7);

      if ( parms ) { 

        if ( parms.filtros ) { 
          _.assign(this.filtro, parms.filtros);
        }

        if ( parms.dre ) { 
          this.filtro.dre = true;
        }

        if ( parms.mes == 'T' ) { 
          this.referencia = "";
        } else if ( parms.mes ) {
          switch (parms.tempo) {
            case 'diario':
              this.filtro.periodo = "ld";
              this.filtro.inicio = parms.mes;
              break;

            case 'livre': 
              this.filtro.periodo = '';
              parms.mes = '';
              break;
          
            default:
              this.filtro.periodo = "lm";
              break;
          }
          this.filtro.mes = parms.mes;

          this.referencia = parms.mes;
        }

        if ( parms.natureza ) { 
          this.filtro.natureza = parms.natureza;
        }

        if ( parms.tipo_data ) { 
          this.filtro.tipo_data = parms.tipo_data;
        }

        if ( parms.id_categoria ) { 
          this.filtro.id_categoria = parms.id_categoria;
        } else if ( parms.categoria ) { 
          this.filtro.search = parms.categoria;
        }

        if ( parms.status ) { 
          this.filtro.status = parms.status;
        }

        if ( parms.id_unidade_operacao ) { 
          this.filtro.id_unidade_operacao = parms.id_unidade_operacao;
        }

        if ( parms.id_centro_custo ) { 
          this.filtro.id_centro_custo = parms.id_centro_custo;
        }

        if ( parms.id_forma_pagamento ) { 
          this.filtro.id_forma_pagamento = parms.id_forma_pagamento;
        }

        if ( parms.tipo == 'R' || parms.tipo == 'C' ) { 
          this.filtro.status = 'F';
        } 

        if ( parms.conciliado ) { 
          this.filtro.conciliado = true;
        } 

      }

      if ( this.referencia ) { 
        this.from = this.referencia + '-01';
        this.to = moment(this.referencia + '-01').endOf('month').format('YYYY-MM-DD');
      }

    },

    gerar_opcoes_tipos_servico() {
      this.tipos_servico = [
        { id: '01', search: '01 - Cobrança' },
        { id: '03', search: '03 - Boleto de Pagamento Eletrônico' },
        { id: '04', search: '04 - Conciliação Bancária' },
        { id: '05', search: '05 - Débitos' },
        { id: '06', search: '06 - Custódia de Cheques' },
        { id: '07', search: '07 - Gestão de Caixa' },
        { id: '08', search: '08 - Consulta/Informação Margem' },
        { id: '09', search: '09 - Averbação da Consignação/Retenção' },
        { id: '10', search: '10 - Pagamento Dividendos' },
        { id: '11', search: '11 - Manutenção da Consignação' },
        { id: '12', search: '12 - Consignação de Parcelas' },
        { id: '13', search: '13 - Glosa da Consignação (INSS)' },
        { id: '14', search: '14 - Consulta de Tributos a pagar' },
        { id: '20', search: '20 - Pagamento Fornecedor' },
        { id: '22', search: '22 - Pagamento de Contas, Tributos e Impostos' },
        { id: '23', search: '23 - Interoperabilidade entre Contas de Instituições de Pagamentos' },
        { id: '25', search: '25 - Compror' },
        { id: '26', search: '26 - Compror Rotativo' },
        { id: '29', search: '29 - Alegação do Pagador' },
        { id: '30', search: '30 - Pagamento Salários' },
        { id: '32', search: '32 - Pagamento de honorários' },
        { id: '33', search: '33 - Pagamento de bolsa auxílio' },
        { id: '34', search: '34 - Pagamento de prebenda (remuneração a padres e sacerdotes)' },
        { id: '40', search: '40 - Vendor' },
        { id: '41', search: '41 - Vendor a Termo' },
        { id: '50', search: '50 - Pagamento Sinistros Segurados' },
        { id: '60', search: '60 - Pagamento Despesas Viajante em Trânsito' },
        { id: '70', search: '70 -Pagamento Autorizado' },
        { id: '75', search: '75 - Pagamento Credenciados' },
        { id: '77', search: '77 - Pagamento de Remuneração' },
        { id: '80', search: '80 - Pagamento Representantes / Vendedores Autorizados' },
        { id: '90', search: '90 - Pagamento Benefícios' },
        { id: '98', search: '98 - Pagamentos Diversos' }
      ];

    },

    gerar_opcoes_formas_lancamento() {

      this.formas_lancamento= [
        { id: '00', search: 'Automático' },
        { id: '01', search: '01 - Crédito em Conta Corrente/Salário' },
        { id: '02', search: '02 - Cheque Pagamento / Administrativo' },
        { id: '03', search: '03 - DOC/TED (1) (2)' },
        { id: '04', search: '04 - Cartão Salário (somente para Tipo de Serviço = \'30\')' },
        { id: '05', search: '05 - Crédito em Conta Poupança' },
        { id: '10', search: '10 - OP à Disposição' },
        { id: '11', search: '11 - Pagamento de Contas e Tributos com Código de Barras' },
        { id: '16', search: '16 - Tributo - DARF Normal' },
        { id: '17', search: '17 - Tributo - GPS (Guia da Previdência Social)' },
        { id: '18', search: '18 - Tributo - DARF Simples' },
        { id: '19', search: '19 - Tributo - IPTU – Prefeituras' },
        { id: '20', search: '20 - Pagamento com Autenticação' },
        { id: '21', search: '21 - Tributo – DARJ' },
        { id: '22', search: '22 - Tributo - GARE-SP ICMS' },
        { id: '23', search: '23 - Tributo - GARE-SP DR' },
        { id: '24', search: '24 - Tributo - GARE-SP ITCMD' },
        { id: '25', search: '25 - Tributo - IPVA' },
        { id: '26', search: '26 - Tributo - Licenciamento' },
        { id: '27', search: '27 - Tributo – DPVAT' },
        { id: '30', search: '30 - Liquidação de Títulos do Próprio Banco' },
        { id: '31', search: '31 - Pagamento de Títulos de Outros Bancos' },
        { id: '40', search: '40 - Extrato de Conta Corrente' },
        { id: '41', search: '41 - TED – Outra Titularidade (1)' },
        { id: '43', search: '43 - TED – Mesma Titularidade (1)' },
        { id: '44', search: '44 - TED para Transferência de Conta Investimento' },
        { id: '45', search: '45 - PIX Transferência' },
        { id: '47', search: '47 - PIX QR-CODE' },
        { id: '50', search: '50 - Débito em Conta Corrente' },
        { id: '70', search: '70 - Extrato para Gestão de Caixa' },
        { id: '71', search: '71 - Depósito Judicial em Conta Corrente' },
        { id: '72', search: '72 - Depósito Judicial em Poupança' },
        { id: '73', search: '73 - Extrato de Conta Investimento' },
        { id: '80', search: '80 - Pagamento de tributos municipais ISS – LCP 157 – próprio Banco' },
        { id: '81', search: '81 - Pagamento de Tributos Municipais ISS – LCP 157 – outros Bancos' }
      ];

    }

  },

  created () { 
    this.preencher_parms(this.parms);
  },

  beforeMount() { 
    if ( this.$store.state.user.id_unidade_operacao && !this.parms ) { 
      this.filtro.id_unidade_operacao = this.$store.state.user.id_unidade_operacao;
    }

    this.gerar_opcoes_tipos_servico();
    this.gerar_opcoes_formas_lancamento();
  },
  
  mounted() {
    if ( !this.block_redir ) { 
      this.$store.commit("setBreadcrumb", [
        { name: "Financeiro", path: "/financeiro/visao" },
        { name: "Lançamento", path: "/financeiro/lancamento" }
      ]);

      if ( this.$route.path != '/financeiro/lancamento' ) { 
        this.$router.push({ path: '/financeiro/lancamento' });
      }
    }

    if ( this.$store.state.contexto && this.$store.state.contexto.lanc_configs ) { 
      this.conta_ad = this.$store.state.contexto.lanc_conta_ad;
      this.acesso_edicao = this.$store.state.contexto.lanc_acesso_edicao;
    } else { 
      this.$util.loadItem(this, { 
        service: 'financeiro',
        func: 'configs',
      })
      .then(res => { 
        this.conta_ad = res.conta_ad;
        this.acesso_edicao = res.edicao;

        this.$store.commit('setContexto', { lanc_configs: true, lanc_conta_ad: res.conta_ad, lanc_acesso_edicao: res.edicao });
      });
    }

    this.$nextTick(() =>  { 
      this.montando = false;

      if ( this.parms && !this.fluxo ) { 
        this.load();
      }
    });
  },

  updated () { 
    $('[data-toggle="tooltip"]').tooltip();
  }
  
};
</script>
